export var DEFAULT_Y = 0; // é»è®¤ç y çå¼
// åç§»ä¹åï¼é´è·
export var MARGIN_RATIO = 1 / 2;
export var DODGE_RATIO = 1 / 2;
// æ£ç¹åå¼ä¹åï¼è·ç¦»è¾¹ççè·ç¦»
export var GAP = 0.05;
//# sourceMappingURL=constant.js.map